import * as React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Typography from '../components/Typography';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';


const HeaderRoot = styled('section')(({ theme }) => ({
  color: theme.palette.common.white,
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  [theme.breakpoints.up('sm')]: {
    height: '80vh',
    minHeight: 100,
    maxHeight: 400,
  },
}));

const Background = styled('div')({
  position: 'absolute',
  left: 0,
  right: 0,
  top: '-64px',
  bottom: 0,
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  zIndex: -2,
});

function Header(props) {
  const { sxBackground, children, title = "Default Title" } = props;

  return (
    <>
    <HeaderRoot>
      <Container
        sx={{
          mt: 3,
          mb: 5,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
    <Typography
      // component="h4"
      sx={{ 
        mt: 4, 
        mb: 2,
        fontWeight: 'bold',
        fontSize: '5em',
      }}
    >
      {title}
    </Typography>
      {children}
        <Box
          sx={{
            position: 'absolute',
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            backgroundColor: 'common.black',
            opacity: 0.5,
            zIndex: -1,
          }}
        />
        <Background sx={sxBackground} />
      </Container>
    </HeaderRoot>
    </>
  );
}

Header.propTypes = {
  children: PropTypes.node,
  sxBackground: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool]),
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};

export default Header;
